module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hint":"Notify by"}}')
  delete Component.options._Ctor
}
